module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.759ea19b.woff";